import { formatNumber } from "@sdk/shared/lib/format";
import { OrderDetails as OrderDetailsType } from "@sdk/shared/types/order.types";
import { PaymentMethodSection } from "@shared/src/components/modules/orders/components/PaymentMethodSection";

export function OrderDetails(props: {
  tradeType: string;
  tokenSymbol: string;
  traderNetworkId: number;
  merchantNetworkId: number;
  currencySymbol: string;
  price: number;
  quantity: number;
}) {
  return (
    <div className="border-2 border-border-secondary rounded-3xl p-4 sm:p-6">
      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <p className="text-text-secondary">Price</p>
          <p className="font-medium">
            {props.price} {props.currencySymbol}
          </p>
        </div>
        <div className="flex justify-between items-center">
          <p className="text-text-secondary">Crypto Amount</p>
          <p className="font-medium">
            {props.quantity} {props.tokenSymbol}
          </p>
        </div>
        <div className="flex justify-between items-center">
          <p className="text-text-secondary">Fiat Amount</p>
          <p className="font-medium">
            {formatNumber(props.quantity * props.price)} {props.currencySymbol}
          </p>
        </div>
      </div>
    </div>
  );
}
